var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"white--text",attrs:{"to":{ name: 'garden', params: { gardenId: _vm.gardenId } }}},[_vm._v(" "+_vm._s(_vm.garden ? _vm.garden.name : _vm.$app.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }